/**
 * Opened from inside the Golf Fore Good app (?src=app on the first URL).
 *
 * The app shows this site in an in-app browser sheet. Apple counts a
 * purchase made there as buying inside the app, so digital add-ons (the
 * Digital Contact Card / Swag Bag offer) must not be sold on that path; the
 * real-world sponsorship itself is fine (App Review 3.1.3(e)). Sponsors who
 * want the add-on get it from the organizer's emailed link instead.
 *
 * Remembered for the session: internal navigation drops the query string
 * (same reason App.tsx persists the embed key).
 */
const STORAGE_KEY = 'tn-in-app';

let inApp = false;

function capture(search: string) {
  if (new URLSearchParams(search).get('src') === 'app') {
    inApp = true;
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* noop */
    }
  }
}

if (typeof window !== 'undefined') capture(window.location.search);

export function isInApp(): boolean {
  if (inApp) return true;
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
